import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Materials.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class Materials extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }
  
  render() {

    const { data } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section} d-lg-none`}>
        <Container>
          <div className={styles.section_title} dangerouslySetInnerHTML={{__html: data?.title}} />
          <div className={styles.section_text} dangerouslySetInnerHTML={{__html: data?.text}} />
          <div className={styles.content}>
            <div className={styles.left}>
              {data?.list.map( ( elm, k ) => {
                return (
                  <>
                    <div className={styles.block_left}>
                      <div className={styles.b_title}>
                        <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.title}} />
                        <div>{this.formatSlideNumber(k)}</div>
                      </div>
                      <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                    </div>
                    {k == 1 &&
                      <div className={styles.block_right}>
                        <Image src={data?.image} alt={data?.title} width={438} height={400} />
                      </div>
                    }
                  </>
                )
              } )}
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Materials.propTypes = {
  data: PropTypes.object
}

Materials.defaultProps = {
  data: {}
}

export default Materials